import ChevronDown from '~/icons/chevron-down.svg';
import ChevronUp from '~/icons/chevron-up.svg';
import { Button } from '~/shared/components/Button/Button';
import { IToggleableButton } from '../models/M170ProductFilter';

export const ToggleableButton = ({ expanded, label, onToggle }: IToggleableButton) => (
	<Button
		type="button"
		variant="plain"
		onClick={() => onToggle()}
		icon={expanded ? <ChevronUp /> : <ChevronDown />}
		role="tab"
		aria-label={label}
		aria-selected={expanded}
	>
		{label}
	</Button>
);
